module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-contents",
    on: {
      "click": function($event) {
        return _vm.$emit('showDetail', _vm.contentsDetail)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getContentsThumbnailPath(_vm.contentsDetail.contentid, _vm.showScreen, _vm.gridType),
      "alt": _vm.contentsDetail.content_name
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layer"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-name font28"
  }, [_vm._v(_vm._s(_vm.contentsDetail.content_name))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-570cab9c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-570cab9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/store/StoreListItem.vue
// module id = 721
// module chunks = 1